import * as DB from "./db";

export default ($axios) => ({
  namespaced: true,
  state: {
    cources: DB.cources,
  },
});
